'use strict';

var compare = {
	initPrintComparison: function () {
		$('.print-page').on('click', function (e) {
			var obj = {'event': 'printComparison'};
			$.extend(obj, getCompareData(e));
			dataLayer.push(obj);
		});
	},
	initCompareDetails: function () {
		$('.attribute-group-title.details').on('click', function (e) {
			var obj = {'event': 'compareDetails'};
			$.extend(obj, getCompareData(e));
			dataLayer.push(obj);
		});
	},
	initCompareIngredients: function () {
		$('.attribute-group-title.Ingredients').on('click', function (e) {
			var obj = {'event': 'compareIngredients'};
			$.extend(obj, getCompareData(e));
			dataLayer.push(obj);
		});
	}
};

/**
 * Gets appropriate data from the page
 *
 * @returns {Object}
 */
function getCompareData(e) {
	var obj = {
		'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.className,
		'category_name': getCategoryName()
	};
	$.extend(obj, getIDsAndNames());
	return obj;
}

/**
 * Concatenates product IDs and product Names which are added for comparison
 *
 * @returns {Object}
 */
function getIDsAndNames() {
	var productIDs = '';
	var productNames = '';
	var productTiles = $('.product-tile');
	productTiles.each(function () {
		// concatenate product IDs
		if (productIDs === '') {
			productIDs += $(this).data('itemid');
		} else {
			productIDs += '|' + $(this).data('itemid');
		}
		// concatenate product names
		if (productNames === '') {
			productNames += $(this).find('.product-name a').attr('title');
		} else {
			productNames += '|' + $(this).find('.product-name a').attr('title');
		}
	});
	var obj = {
		'product_compare_IDs': productIDs,
		'product_compare_names': productNames
	};
	return obj;
}

/**
 * Retrieves category name from the page
 *
 * @returns {String}
 */
function getCategoryName() {
	var categoryName = '';
	if ($('input[name=currentCompareCat]').length > 0) {
		categoryName = $('input[name=currentCompareCat]').val();
	}
	if ($('#compare-category-list').length > 0) {
		categoryName = $('#compare-category-list').find('option:selected').text();
	}
	return categoryName;
}

module.exports = compare;
